var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShapeLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 142,
    viewBox: "0 0 28 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0005 76.5C28.5005 62.5 19.2335 52.1914 10.0004 39C3.00098 29 0.000579834 10.5 0.000524521 0L0.0012722 142C0.0012722 120.5 5.50128 113 11.5013 105.5C17.5013 98 25.5005 90.5 27.0005 76.5Z",
    fill: "#070710"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLeft);
export default __webpack_public_path__ + "static/media/shape_left.c499f36d2d5aa11465ecaba9e73cb6b1.svg";
export { ForwardRef as ReactComponent };